/**
 * Demo Mode API
 * API client for demo-specific endpoints
 */

import { useQuery } from '@tanstack/react-query'
import { apiClient } from './client'

export interface DemoQuery {
  id: number
  text: string
}

export interface DemoQueriesResponse {
  queries: DemoQuery[]
}

export interface DemoStatusResponse {
  is_demo_mode: boolean
  queries_remaining: number
  max_queries: number
}

/**
 * Get list of predefined demo queries
 */
export function useDemoQueries() {
  return useQuery<DemoQueriesResponse>({
    queryKey: ['demo', 'queries'],
    queryFn: async () => {
      const response = await apiClient.get<DemoQueriesResponse>('/demo/queries')
      return response.data
    },
    staleTime: Infinity, // Queries don't change during session
    retry: 1,
  })
}

/**
 * Get demo status for current session
 */
export function useDemoStatus(sessionId: string, enabled = true) {
  return useQuery<DemoStatusResponse>({
    queryKey: ['demo', 'status', sessionId],
    queryFn: async () => {
      const response = await apiClient.get<DemoStatusResponse>('/demo/status', {
        params: { session_id: sessionId },
      })
      return response.data
    },
    enabled: enabled && !!sessionId,
    refetchInterval: false, // Don't auto-refetch
    retry: 1,
  })
}
